var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var _a;
import dayjs from 'dayjs';
import { MemberAllocationMutationTypes } from '@/types/member-allocation';
import MemberAllocationApiClient from '@/plugins/apis/v2/member-allocation-api-client';
import { memberAllocationWindowCache, mergeUsersIntoMaps, buildDayKeysFromRange, USER_LIMIT, MEMBER_SCROLL_CHUNK } from '@/services/member-allocation-window-cache';
import { buildAllocationTaskFromApiProject } from '@/utils/member-allocation-format';
var MEMBER_SCROLL_STEP = 20;
var CACHE_BYPASS_MS_AFTER_MUTATION = 5000;
function normalizeWindowOffset(params) {
    var requestedOffset = params.requestedOffset, totalUsers = params.totalUsers;
    var snapped = Math.max(0, Math.floor(requestedOffset / MEMBER_SCROLL_STEP) * MEMBER_SCROLL_STEP);
    if (typeof totalUsers !== 'number')
        return snapped;
    var maxStart = Math.max(0, totalUsers - MEMBER_SCROLL_CHUNK);
    return Math.max(0, Math.min(snapped, maxStart));
}
function shallowCloneTasksByMember(src) {
    var out = {};
    for (var _i = 0, _a = Object.keys(src); _i < _a.length; _i++) {
        var uid = _a[_i];
        out[uid] = __assign({}, src[uid]);
    }
    return out;
}
/** Paginate timeline window and merge into copies of members/tasks (does not touch Vuex). */
function fetchFullMonthForMerge(companyId, baseMembers, baseTasks) {
    return __awaiter(this, void 0, Promise, function () {
        var members, tasks, targetMemberIds, mergedTargetMemberIds, offset, mergedDays, first, res, data, days, _i, _a, user, userId, meta, next;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    members = __spreadArrays(baseMembers);
                    tasks = shallowCloneTasksByMember(baseTasks);
                    targetMemberIds = new Set(baseMembers.map(function (m) { return m.id; }).filter(Boolean));
                    mergedTargetMemberIds = new Set();
                    offset = 0;
                    mergedDays = [];
                    first = true;
                    _b.label = 1;
                case 1:
                    if (!true) return [3 /*break*/, 3];
                    return [4 /*yield*/, MemberAllocationApiClient.fetchTimeline(companyId, {
                            user_offset: offset,
                            user_limit: USER_LIMIT
                        })];
                case 2:
                    res = _b.sent();
                    data = res.data;
                    days = buildDayKeysFromRange(data.start_date, data.end_date);
                    if (first) {
                        mergedDays = days;
                        first = false;
                    }
                    mergeUsersIntoMaps(members, tasks, data.users, days, {
                        allowAddMembers: false,
                        targetMemberIds: targetMemberIds
                    });
                    for (_i = 0, _a = data.users; _i < _a.length; _i++) {
                        user = _a[_i];
                        userId = user.id || '';
                        if (!userId)
                            continue;
                        if (targetMemberIds.has(userId)) {
                            mergedTargetMemberIds.add(userId);
                        }
                    }
                    // Horizontal month paging should only enrich currently loaded members.
                    if (mergedTargetMemberIds.size >= targetMemberIds.size)
                        return [3 /*break*/, 3];
                    meta = data.meta;
                    if (!meta || !meta.has_more_users)
                        return [3 /*break*/, 3];
                    next = meta.next_user_offset;
                    if (next == null)
                        return [3 /*break*/, 3];
                    offset = next;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, { mergedDays: mergedDays, members: members, tasks: tasks }];
            }
        });
    });
}
function fetchSingleUserTasksForMonth(options) {
    return __awaiter(this, void 0, Promise, function () {
        var companyId, userId, maxOffset, offset, tasksByDay, res, data, user, _i, _a, day, tasks, processPairs, _b, _c, project, _d, _e, lp, _f, processPairs_1, pair, meta;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    companyId = options.companyId, userId = options.userId, maxOffset = options.maxOffset;
                    offset = 0;
                    tasksByDay = {};
                    _g.label = 1;
                case 1:
                    if (!(offset <= maxOffset)) return [3 /*break*/, 3];
                    return [4 /*yield*/, MemberAllocationApiClient.fetchTimeline(companyId, {
                            user_offset: offset,
                            user_limit: USER_LIMIT
                        })];
                case 2:
                    res = _g.sent();
                    data = res.data;
                    user = (data.users || []).find(function (item) { return item.id === userId; });
                    if (user) {
                        for (_i = 0, _a = user.days || []; _i < _a.length; _i++) {
                            day = _a[_i];
                            tasks = [];
                            processPairs = [];
                            for (_b = 0, _c = day.projects || []; _b < _c.length; _b++) {
                                project = _c[_b];
                                for (_d = 0, _e = project.large_processes || []; _d < _e.length; _d++) {
                                    lp = _e[_d];
                                    processPairs.push({ project: project, lp: lp });
                                }
                            }
                            processPairs.sort(function (a, b) { return a.lp.large_position - b.lp.large_position; });
                            for (_f = 0, processPairs_1 = processPairs; _f < processPairs_1.length; _f++) {
                                pair = processPairs_1[_f];
                                tasks.push(buildAllocationTaskFromApiProject(pair.project, pair.lp));
                            }
                            tasksByDay[day.date] = tasks;
                        }
                        return [2 /*return*/, { tasksByDay: tasksByDay }];
                    }
                    meta = data.meta;
                    if (!meta || !meta.has_more_users || meta.next_user_offset == null) {
                        return [3 /*break*/, 3];
                    }
                    if (meta.next_user_offset <= offset) {
                        return [3 /*break*/, 3];
                    }
                    offset = meta.next_user_offset;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, { tasksByDay: null }];
            }
        });
    });
}
function fetchMonthForCurrentMemberWindow(options) {
    return __awaiter(this, void 0, Promise, function () {
        var companyId, startOffset, chunkSize, currentMembers, currentTasksByMemberAndDay, timelineReference, windowData, mergedDays, nextTasksByMemberAndDay, targetMemberIds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    companyId = options.companyId, startOffset = options.startOffset, chunkSize = options.chunkSize, currentMembers = options.currentMembers, currentTasksByMemberAndDay = options.currentTasksByMemberAndDay, timelineReference = options.timelineReference;
                    return [4 /*yield*/, memberAllocationWindowCache.fetchMemberWindowWithCache({
                            companyId: companyId,
                            startOffset: startOffset,
                            chunkSize: chunkSize,
                            timelineReference: timelineReference
                        })];
                case 1:
                    windowData = _a.sent();
                    mergedDays = windowData.days;
                    nextTasksByMemberAndDay = shallowCloneTasksByMember(currentTasksByMemberAndDay);
                    targetMemberIds = new Set(currentMembers.map(function (member) { return member.id; }).filter(Boolean));
                    targetMemberIds.forEach(function (memberId) {
                        var currentRow = nextTasksByMemberAndDay[memberId] || {};
                        var windowRow = windowData.tasksByMemberAndDay[memberId] || {};
                        nextTasksByMemberAndDay[memberId] = __assign(__assign({}, currentRow), windowRow);
                        for (var _i = 0, mergedDays_1 = mergedDays; _i < mergedDays_1.length; _i++) {
                            var dateKey = mergedDays_1[_i];
                            if (!nextTasksByMemberAndDay[memberId][dateKey]) {
                                nextTasksByMemberAndDay[memberId][dateKey] = [];
                            }
                        }
                    });
                    return [2 /*return*/, {
                            mergedDays: mergedDays,
                            tasksByMemberAndDay: nextTasksByMemberAndDay
                        }];
            }
        });
    });
}
function resolveRefreshMonths(params) {
    var loadedMonths = Array.from(new Set(params.dayKeys.map(function (dayKey) { return dayKey.slice(0, 7); })));
    if (!loadedMonths.length)
        return [];
    var baseMonths = params.visibleMonths && params.visibleMonths.length
        ? Array.from(new Set(params.visibleMonths))
        : loadedMonths;
    var expanded = new Set();
    for (var _i = 0, baseMonths_1 = baseMonths; _i < baseMonths_1.length; _i++) {
        var month = baseMonths_1[_i];
        var idx = loadedMonths.indexOf(month);
        if (idx < 0)
            continue;
        expanded.add(loadedMonths[idx]);
        if (idx - 1 >= 0)
            expanded.add(loadedMonths[idx - 1]);
        if (idx + 1 < loadedMonths.length)
            expanded.add(loadedMonths[idx + 1]);
    }
    return loadedMonths.filter(function (month) { return expanded.has(month); });
}
function getLoadedMonths(dayKeys) {
    return Array.from(new Set(dayKeys.map(function (dayKey) { return dayKey.slice(0, 7); })));
}
function resolveUserNodeFromResponse(data, memberId) {
    var _a, _b;
    var roots = [data, data === null || data === void 0 ? void 0 : data.data, data === null || data === void 0 ? void 0 : data.result].filter(Boolean);
    for (var _i = 0, roots_1 = roots; _i < roots_1.length; _i++) {
        var root = roots_1[_i];
        var user = root === null || root === void 0 ? void 0 : root.user;
        if (user && String(user.id || '') === memberId && Array.isArray(user.days)) {
            return user;
        }
        var usersGroups = [
            root === null || root === void 0 ? void 0 : root.users,
            (_a = root === null || root === void 0 ? void 0 : root.member_large_processes_timeline) === null || _a === void 0 ? void 0 : _a.users,
            (_b = root === null || root === void 0 ? void 0 : root.timeline) === null || _b === void 0 ? void 0 : _b.users
        ];
        for (var _c = 0, usersGroups_1 = usersGroups; _c < usersGroups_1.length; _c++) {
            var users = usersGroups_1[_c];
            if (!Array.isArray(users))
                continue;
            var matched = users.find(function (item) { return String((item === null || item === void 0 ? void 0 : item.id) || '') === memberId; });
            if (matched && Array.isArray(matched.days)) {
                return matched;
            }
        }
    }
    return null;
}
function resolveUserDaysFromResponse(data, memberId) {
    var _a;
    return ((_a = resolveUserNodeFromResponse(data, memberId)) === null || _a === void 0 ? void 0 : _a.days) || [];
}
function hasExplicitEmptyDaysFromResponse(data, memberId) {
    var userNode = resolveUserNodeFromResponse(data, memberId);
    return !!userNode && userNode.days.length === 0;
}
export var state = function () { return ({
    monthValue: dayjs().format('YYYY-MM'),
    dayKeys: [],
    loadedMembers: [],
    loadedMemberStartIndex: 0,
    tasksByMemberAndDay: {},
    hasMoreMembers: true,
    hasMoreMembersPrev: false,
    userOffset: 0,
    isLoading: false,
    totalUsers: null,
    queuedTimelineOffset: null,
    staleLoadedMonths: []
}); };
export var getters = {
    monthValue: function (state) {
        return state.monthValue;
    },
    dayKeys: function (state) {
        return state.dayKeys;
    },
    loadedMembers: function (state) {
        return state.loadedMembers;
    },
    loadedMemberStartIndex: function (state) {
        return state.loadedMemberStartIndex;
    },
    tasksByMemberAndDay: function (state) {
        return state.tasksByMemberAndDay;
    },
    hasMoreMembers: function (state) {
        return state.hasMoreMembers;
    },
    hasMoreMembersPrev: function (state) {
        return state.hasMoreMembersPrev;
    },
    isLoading: function (state) {
        return state.isLoading;
    },
    totalUsers: function (state) {
        return state.totalUsers;
    }
};
export var mutations = (_a = {},
    _a[MemberAllocationMutationTypes.SET_MONTH_VALUE] = function (state, payload) {
        state.monthValue = payload;
    },
    _a[MemberAllocationMutationTypes.SET_DAY_KEYS] = function (state, payload) {
        state.dayKeys = payload;
    },
    _a[MemberAllocationMutationTypes.SET_LOADED_MEMBERS] = function (state, payload) {
        state.loadedMembers = payload;
    },
    _a[MemberAllocationMutationTypes.SET_LOADED_MEMBER_START_INDEX] = function (state, payload) {
        state.loadedMemberStartIndex = payload;
    },
    _a[MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY] = function (state, payload) {
        state.tasksByMemberAndDay = payload;
    },
    _a[MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS] = function (state, payload) {
        state.hasMoreMembers = payload;
    },
    _a[MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS_PREV] = function (state, payload) {
        state.hasMoreMembersPrev = payload;
    },
    _a[MemberAllocationMutationTypes.SET_USER_OFFSET] = function (state, payload) {
        state.userOffset = payload;
    },
    _a[MemberAllocationMutationTypes.SET_IS_LOADING] = function (state, payload) {
        state.isLoading = payload;
    },
    _a[MemberAllocationMutationTypes.SET_TOTAL_USERS] = function (state, payload) {
        state.totalUsers = payload;
    },
    _a[MemberAllocationMutationTypes.UPDATE_MEMBER_LIST] = function (state, payload) {
        state.loadedMembers = payload;
    },
    _a[MemberAllocationMutationTypes.SET_QUEUED_TIMELINE_OFFSET] = function (state, payload) {
        state.queuedTimelineOffset = payload;
    },
    _a[MemberAllocationMutationTypes.SET_STALE_LOADED_MONTHS] = function (state, payload) {
        state.staleLoadedMonths = payload;
    },
    _a);
export var actions = {
    initState: function (_a) {
        var commit = _a.commit;
        memberAllocationWindowCache.reset();
        commit(MemberAllocationMutationTypes.SET_QUEUED_TIMELINE_OFFSET, null);
        commit(MemberAllocationMutationTypes.SET_STALE_LOADED_MONTHS, []);
        commit(MemberAllocationMutationTypes.SET_LOADED_MEMBERS, []);
        commit(MemberAllocationMutationTypes.SET_LOADED_MEMBER_START_INDEX, 0);
        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, {});
        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, true);
        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS_PREV, false);
        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, 0);
        commit(MemberAllocationMutationTypes.SET_TOTAL_USERS, null);
        commit(MemberAllocationMutationTypes.SET_DAY_KEYS, []);
    },
    initTimeline: function (_a, payload) {
        var commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        memberAllocationWindowCache.reset();
                        commit(MemberAllocationMutationTypes.SET_QUEUED_TIMELINE_OFFSET, null);
                        commit(MemberAllocationMutationTypes.SET_STALE_LOADED_MONTHS, []);
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, 0);
                        commit(MemberAllocationMutationTypes.SET_LOADED_MEMBER_START_INDEX, 0);
                        commit(MemberAllocationMutationTypes.SET_LOADED_MEMBERS, []);
                        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, {});
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, true);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS_PREV, false);
                        commit(MemberAllocationMutationTypes.SET_TOTAL_USERS, null);
                        return [4 /*yield*/, dispatch('fetchTimeline', {
                                companyId: payload.companyId,
                                timelineReference: payload.timelineReference
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    fetchTimeline: function (_a, payload) {
        var commit = _a.commit, state = _a.state, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var requestOffset, requestGeneration, isBackwardRequest, canLoadDirection, total, reachedTotal, windowData, days, currentMembers, currentTasks, metaTotal, nextOffset, effectiveTotal, nextLoadedEnd, hitTotal, hasMoreByMeta, hasMoreByOffset, hasMoreByChunkSize, hasMore, hasMorePrev, queuedOffset;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestOffset = state.userOffset;
                        requestGeneration = memberAllocationWindowCache.getGeneration();
                        isBackwardRequest = requestOffset < state.loadedMemberStartIndex;
                        canLoadDirection = isBackwardRequest ? state.hasMoreMembersPrev : state.hasMoreMembers;
                        total = state.totalUsers;
                        reachedTotal = !isBackwardRequest && typeof total === 'number' && requestOffset >= total;
                        if (state.isLoading) {
                            commit(MemberAllocationMutationTypes.SET_QUEUED_TIMELINE_OFFSET, requestOffset);
                            return [2 /*return*/];
                        }
                        if (!canLoadDirection || reachedTotal)
                            return [2 /*return*/];
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 7]);
                        return [4 /*yield*/, memberAllocationWindowCache.fetchMemberWindowWithCache({
                                companyId: payload.companyId,
                                startOffset: requestOffset,
                                chunkSize: MEMBER_SCROLL_CHUNK,
                                timelineReference: payload.timelineReference
                            })];
                    case 2:
                        windowData = _b.sent();
                        days = windowData.days;
                        // First chunk only: set columns. Vertical page 2+ keeps extended (multi-month) dayKeys.
                        if (state.loadedMembers.length === 0) {
                            commit(MemberAllocationMutationTypes.SET_DAY_KEYS, days);
                        }
                        currentMembers = windowData.members;
                        currentTasks = __assign(__assign({}, windowData.tasksByMemberAndDay), state.tasksByMemberAndDay);
                        if (requestGeneration !== memberAllocationWindowCache.getGeneration()) {
                            return [2 /*return*/];
                        }
                        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, currentTasks);
                        metaTotal = windowData.totalUsers;
                        if (metaTotal != null) {
                            commit(MemberAllocationMutationTypes.SET_TOTAL_USERS, metaTotal);
                        }
                        nextOffset = windowData.nextOffset;
                        effectiveTotal = metaTotal !== null && metaTotal !== void 0 ? metaTotal : state.totalUsers;
                        nextLoadedEnd = requestOffset + currentMembers.length;
                        hitTotal = typeof effectiveTotal === 'number' && nextLoadedEnd >= effectiveTotal;
                        hasMoreByMeta = windowData.hasMoreUsers;
                        hasMoreByOffset = typeof effectiveTotal === 'number' ? nextOffset < effectiveTotal : false;
                        hasMoreByChunkSize = currentMembers.length >= MEMBER_SCROLL_CHUNK;
                        hasMore = !hitTotal && (hasMoreByMeta || hasMoreByOffset || hasMoreByChunkSize);
                        hasMorePrev = requestOffset > 0;
                        commit(MemberAllocationMutationTypes.SET_LOADED_MEMBERS, currentMembers);
                        commit(MemberAllocationMutationTypes.SET_LOADED_MEMBER_START_INDEX, requestOffset);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, hasMore);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS_PREV, hasMorePrev);
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, nextOffset);
                        // Warm next/prev windows in background to reduce fling blank gaps.
                        memberAllocationWindowCache.prefetchMemberWindow({
                            companyId: payload.companyId,
                            startOffset: requestOffset + MEMBER_SCROLL_STEP,
                            chunkSize: MEMBER_SCROLL_CHUNK,
                            timelineReference: payload.timelineReference
                        });
                        memberAllocationWindowCache.prefetchMemberWindow({
                            companyId: payload.companyId,
                            startOffset: Math.max(0, requestOffset - MEMBER_SCROLL_STEP),
                            chunkSize: MEMBER_SCROLL_CHUNK,
                            timelineReference: payload.timelineReference
                        });
                        memberAllocationWindowCache.prefetchMemberWindow({
                            companyId: payload.companyId,
                            startOffset: Math.max(0, requestOffset - MEMBER_SCROLL_STEP * 2),
                            chunkSize: MEMBER_SCROLL_CHUNK,
                            timelineReference: payload.timelineReference
                        });
                        return [3 /*break*/, 7];
                    case 3:
                        if (requestGeneration === memberAllocationWindowCache.getGeneration()) {
                            commit(MemberAllocationMutationTypes.SET_IS_LOADING, false);
                        }
                        queuedOffset = state.queuedTimelineOffset;
                        if (!(requestGeneration === memberAllocationWindowCache.getGeneration() &&
                            queuedOffset != null &&
                            queuedOffset !== state.loadedMemberStartIndex &&
                            queuedOffset !== state.userOffset)) return [3 /*break*/, 5];
                        commit(MemberAllocationMutationTypes.SET_QUEUED_TIMELINE_OFFSET, null);
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, queuedOffset);
                        return [4 /*yield*/, dispatch('fetchTimeline', {
                                companyId: payload.companyId,
                                timelineReference: payload.timelineReference
                            })];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        commit(MemberAllocationMutationTypes.SET_QUEUED_TIMELINE_OFFSET, null);
                        _b.label = 6;
                    case 6: return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    },
    refreshVisibleTimeline: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var savedOffset, savedHasMore, savedHasMorePrev, savedTotalUsers, baseMembers, mergedTasks, tasks;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (state.isLoading || !state.loadedMembers.length)
                            return [2 /*return*/];
                        savedOffset = state.userOffset;
                        savedHasMore = state.hasMoreMembers;
                        savedHasMorePrev = state.hasMoreMembersPrev;
                        savedTotalUsers = state.totalUsers;
                        baseMembers = __spreadArrays(state.loadedMembers);
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 4]);
                        mergedTasks = shallowCloneTasksByMember(state.tasksByMemberAndDay);
                        return [4 /*yield*/, fetchFullMonthForMerge(payload.companyId, baseMembers, mergedTasks)];
                    case 2:
                        tasks = (_b.sent()).tasks;
                        mergedTasks = tasks;
                        commit(MemberAllocationMutationTypes.SET_LOADED_MEMBERS, baseMembers);
                        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, mergedTasks);
                        return [3 /*break*/, 4];
                    case 3:
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, savedOffset);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, savedHasMore);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS_PREV, savedHasMorePrev);
                        commit(MemberAllocationMutationTypes.SET_TOTAL_USERS, savedTotalUsers);
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    refreshVisibleTimelineByMember: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var memberIndex, globalMemberIndex, maxOffset, savedOffset, savedHasMore, savedHasMorePrev, savedTotalUsers, nextTasksByMemberAndDay, tasksByDay;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (state.isLoading || !state.loadedMembers.length || !payload.userId)
                            return [2 /*return*/];
                        memberIndex = state.loadedMembers.findIndex(function (member) { return member.id === payload.userId; });
                        if (memberIndex < 0)
                            return [2 /*return*/];
                        globalMemberIndex = state.loadedMemberStartIndex + memberIndex;
                        maxOffset = Math.floor(globalMemberIndex / USER_LIMIT) * USER_LIMIT;
                        if (!state.dayKeys.length)
                            return [2 /*return*/];
                        savedOffset = state.userOffset;
                        savedHasMore = state.hasMoreMembers;
                        savedHasMorePrev = state.hasMoreMembersPrev;
                        savedTotalUsers = state.totalUsers;
                        nextTasksByMemberAndDay = shallowCloneTasksByMember(state.tasksByMemberAndDay);
                        if (!nextTasksByMemberAndDay[payload.userId]) {
                            nextTasksByMemberAndDay[payload.userId] = {};
                        }
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, fetchSingleUserTasksForMonth({
                                companyId: payload.companyId,
                                userId: payload.userId,
                                maxOffset: maxOffset
                            })];
                    case 2:
                        tasksByDay = (_b.sent()).tasksByDay;
                        if (tasksByDay) {
                            nextTasksByMemberAndDay[payload.userId] = __assign(__assign({}, nextTasksByMemberAndDay[payload.userId]), tasksByDay);
                        }
                        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, nextTasksByMemberAndDay);
                        return [3 /*break*/, 4];
                    case 3:
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, savedOffset);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, savedHasMore);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS_PREV, savedHasMorePrev);
                        commit(MemberAllocationMutationTypes.SET_TOTAL_USERS, savedTotalUsers);
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    applyUserDaysFromResponse: function (_a, payload) {
        var _b;
        var _c, _d, _e;
        var commit = _a.commit, state = _a.state;
        var memberId = payload.userId;
        if (!memberId)
            return false;
        var responseDays = resolveUserDaysFromResponse(payload.responseData, memberId);
        var explicitEmptyDays = hasExplicitEmptyDaysFromResponse(payload.responseData, memberId);
        if (!responseDays.length && !explicitEmptyDays)
            return false;
        var currentMemberTasks = ((_c = state.tasksByMemberAndDay) === null || _c === void 0 ? void 0 : _c[memberId]) || {};
        var nextMemberTasks = __assign({}, currentMemberTasks);
        var changed = false;
        if (explicitEmptyDays) {
            for (var _i = 0, _f = state.dayKeys; _i < _f.length; _i++) {
                var dateKey = _f[_i];
                nextMemberTasks[dateKey] = [];
            }
            changed = true;
        }
        var responseDateSet = new Set();
        for (var _g = 0, responseDays_1 = responseDays; _g < responseDays_1.length; _g++) {
            var day = responseDays_1[_g];
            var dateKey = String((day === null || day === void 0 ? void 0 : day.date) || '');
            if (!dateKey)
                continue;
            responseDateSet.add(dateKey);
            var projects = Array.isArray(day === null || day === void 0 ? void 0 : day.projects) ? day.projects : [];
            var nextTasks = [];
            var processPairs = [];
            for (var _h = 0, projects_1 = projects; _h < projects_1.length; _h++) {
                var project = projects_1[_h];
                var processes = Array.isArray(project === null || project === void 0 ? void 0 : project.large_processes) ? project.large_processes : [];
                for (var _j = 0, processes_1 = processes; _j < processes_1.length; _j++) {
                    var process = processes_1[_j];
                    processPairs.push({ project: project, process: process });
                }
            }
            processPairs.sort(function (a, b) { return a.process.large_position - b.process.large_position; });
            for (var _k = 0, processPairs_2 = processPairs; _k < processPairs_2.length; _k++) {
                var pair = processPairs_2[_k];
                nextTasks.push(buildAllocationTaskFromApiProject(pair.project, pair.process));
            }
            nextMemberTasks[dateKey] = nextTasks;
            changed = true;
        }
        for (var _l = 0, _m = state.dayKeys; _l < _m.length; _l++) {
            var dateKey = _m[_l];
            if (!responseDateSet.has(dateKey) && ((_e = (_d = nextMemberTasks[dateKey]) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0) > 0) {
                nextMemberTasks[dateKey] = [];
                changed = true;
            }
        }
        if (!changed)
            return false;
        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, __assign(__assign({}, state.tasksByMemberAndDay), (_b = {}, _b[memberId] = nextMemberTasks, _b)));
        return true;
    },
    refreshCurrentMemberWindow: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var months, loadedMonths, currentOffset, currentHasMore, currentHasMorePrev, currentTotalUsers, mergedTasks, tasksByMemberAndDay;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (state.isLoading)
                            return [2 /*return*/];
                        if (!state.loadedMembers.length || !state.dayKeys.length)
                            return [2 /*return*/];
                        months = resolveRefreshMonths({
                            dayKeys: state.dayKeys,
                            visibleMonths: payload.months
                        });
                        if (!months.length)
                            return [2 /*return*/];
                        loadedMonths = getLoadedMonths(state.dayKeys);
                        currentOffset = state.loadedMemberStartIndex;
                        currentHasMore = state.hasMoreMembers;
                        currentHasMorePrev = state.hasMoreMembersPrev;
                        currentTotalUsers = state.totalUsers;
                        memberAllocationWindowCache.setBypassUntil(Date.now() + CACHE_BYPASS_MS_AFTER_MUTATION);
                        memberAllocationWindowCache.reset();
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 4]);
                        mergedTasks = shallowCloneTasksByMember(state.tasksByMemberAndDay);
                        return [4 /*yield*/, fetchMonthForCurrentMemberWindow({
                                companyId: payload.companyId,
                                startOffset: currentOffset,
                                chunkSize: MEMBER_SCROLL_CHUNK,
                                currentMembers: state.loadedMembers,
                                currentTasksByMemberAndDay: mergedTasks
                            })];
                    case 2:
                        tasksByMemberAndDay = (_b.sent()).tasksByMemberAndDay;
                        mergedTasks = tasksByMemberAndDay;
                        commit(MemberAllocationMutationTypes.SET_STALE_LOADED_MONTHS, loadedMonths.filter(function (month) { return !months.includes(month); }));
                        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, mergedTasks);
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, currentOffset);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, currentHasMore);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS_PREV, currentHasMorePrev);
                        if (typeof currentTotalUsers === 'number') {
                            commit(MemberAllocationMutationTypes.SET_TOTAL_USERS, currentTotalUsers);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    refreshDirtyVisibleMonths: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var targetMonths, currentOffset, savedHasMore, savedHasMorePrev, savedTotalUsers, mergedTasks, tasksByMemberAndDay, nextStale;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (state.isLoading)
                            return [2 /*return*/];
                        if (!state.loadedMembers.length || !state.dayKeys.length)
                            return [2 /*return*/];
                        if (!payload.months || payload.months.length === 0)
                            return [2 /*return*/];
                        targetMonths = payload.months.filter(function (month) { return state.staleLoadedMonths.includes(month); });
                        if (!targetMonths.length)
                            return [2 /*return*/];
                        currentOffset = state.loadedMemberStartIndex;
                        savedHasMore = state.hasMoreMembers;
                        savedHasMorePrev = state.hasMoreMembersPrev;
                        savedTotalUsers = state.totalUsers;
                        memberAllocationWindowCache.setBypassUntil(Date.now() + 1000);
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 4]);
                        mergedTasks = shallowCloneTasksByMember(state.tasksByMemberAndDay);
                        return [4 /*yield*/, fetchMonthForCurrentMemberWindow({
                                companyId: payload.companyId,
                                startOffset: currentOffset,
                                chunkSize: MEMBER_SCROLL_CHUNK,
                                currentMembers: state.loadedMembers,
                                currentTasksByMemberAndDay: mergedTasks
                            })];
                    case 2:
                        tasksByMemberAndDay = (_b.sent()).tasksByMemberAndDay;
                        mergedTasks = tasksByMemberAndDay;
                        nextStale = state.staleLoadedMonths.filter(function (m) { return !targetMonths.includes(m); });
                        commit(MemberAllocationMutationTypes.SET_STALE_LOADED_MONTHS, nextStale);
                        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, mergedTasks);
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, currentOffset);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, savedHasMore);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS_PREV, savedHasMorePrev);
                        if (typeof savedTotalUsers === 'number') {
                            commit(MemberAllocationMutationTypes.SET_TOTAL_USERS, savedTotalUsers);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    appendNextMonth: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var priorDayKeys, savedOffset, savedHasMore, lastKey, timelineReference, _b, mergedDays, tasksByMemberAndDay, existing_1, newDays, nextDayKeys;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!state.dayKeys.length || state.isLoading)
                            return [2 /*return*/];
                        priorDayKeys = __spreadArrays(state.dayKeys);
                        savedOffset = state.userOffset;
                        savedHasMore = state.hasMoreMembers;
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, true);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 3, 4]);
                        lastKey = priorDayKeys[priorDayKeys.length - 1];
                        timelineReference = dayjs(lastKey)
                            .startOf('month')
                            .add(3, 'month');
                        return [4 /*yield*/, fetchMonthForCurrentMemberWindow({
                                companyId: payload.companyId,
                                startOffset: state.loadedMemberStartIndex,
                                chunkSize: MEMBER_SCROLL_CHUNK,
                                currentMembers: state.loadedMembers,
                                currentTasksByMemberAndDay: state.tasksByMemberAndDay,
                                timelineReference: timelineReference
                            })];
                    case 2:
                        _b = _c.sent(), mergedDays = _b.mergedDays, tasksByMemberAndDay = _b.tasksByMemberAndDay;
                        if (!mergedDays.length)
                            return [2 /*return*/];
                        existing_1 = new Set(priorDayKeys);
                        newDays = mergedDays.filter(function (d) { return !existing_1.has(d); });
                        if (!newDays.length)
                            return [2 /*return*/];
                        nextDayKeys = __spreadArrays(priorDayKeys, newDays);
                        commit(MemberAllocationMutationTypes.SET_DAY_KEYS, nextDayKeys);
                        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, tasksByMemberAndDay);
                        return [3 /*break*/, 4];
                    case 3:
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, savedOffset);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, savedHasMore);
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    prependPrevMonth: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, Promise, function () {
            var priorDayKeys, savedOffset, savedHasMore, firstKey, timelineReference, _b, mergedDays, tasksByMemberAndDay, existing_2, newDays, nextDayKeys;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!state.dayKeys.length || state.isLoading)
                            return [2 /*return*/, { prependedDayCount: 0 }];
                        priorDayKeys = __spreadArrays(state.dayKeys);
                        savedOffset = state.userOffset;
                        savedHasMore = state.hasMoreMembers;
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, true);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 3, 4]);
                        firstKey = priorDayKeys[0];
                        timelineReference = dayjs(firstKey)
                            .startOf('month')
                            .subtract(3, 'month');
                        return [4 /*yield*/, fetchMonthForCurrentMemberWindow({
                                companyId: payload.companyId,
                                startOffset: state.loadedMemberStartIndex,
                                chunkSize: MEMBER_SCROLL_CHUNK,
                                currentMembers: state.loadedMembers,
                                currentTasksByMemberAndDay: state.tasksByMemberAndDay,
                                timelineReference: timelineReference
                            })];
                    case 2:
                        _b = _c.sent(), mergedDays = _b.mergedDays, tasksByMemberAndDay = _b.tasksByMemberAndDay;
                        if (!mergedDays.length)
                            return [2 /*return*/, { prependedDayCount: 0 }];
                        existing_2 = new Set(priorDayKeys);
                        newDays = mergedDays.filter(function (d) { return !existing_2.has(d); });
                        if (!newDays.length)
                            return [2 /*return*/, { prependedDayCount: 0 }];
                        nextDayKeys = __spreadArrays(newDays, priorDayKeys);
                        commit(MemberAllocationMutationTypes.SET_DAY_KEYS, nextDayKeys);
                        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, tasksByMemberAndDay);
                        return [2 /*return*/, { prependedDayCount: newDays.length }];
                    case 3:
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, savedOffset);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, savedHasMore);
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    updateMonth: function (_a, payload) {
        var _b;
        var commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var timelineReference;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        timelineReference = (_b = payload.timelineReference) !== null && _b !== void 0 ? _b : payload.monthValue;
                        commit(MemberAllocationMutationTypes.SET_MONTH_VALUE, payload.monthValue);
                        return [4 /*yield*/, dispatch('initTimeline', {
                                companyId: payload.companyId,
                                includeNextMonth: payload.includeNextMonth,
                                timelineReference: timelineReference
                            })];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    appendMembers: function (_a, payload) {
        var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var anchorOffset, targetOffset;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!state.hasMoreMembers)
                            return [2 /*return*/];
                        anchorOffset = typeof payload.anchorIndex === 'number'
                            ? payload.anchorIndex - Math.floor(MEMBER_SCROLL_CHUNK * 0.6)
                            : state.loadedMemberStartIndex + MEMBER_SCROLL_STEP;
                        targetOffset = normalizeWindowOffset({
                            requestedOffset: Math.max(state.loadedMemberStartIndex + MEMBER_SCROLL_STEP, anchorOffset),
                            totalUsers: state.totalUsers
                        });
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, targetOffset);
                        return [4 /*yield*/, dispatch('fetchTimeline', { companyId: payload.companyId })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    prependMembers: function (_a, payload) {
        var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var anchorOffset, prevOffset;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (state.loadedMemberStartIndex <= 0)
                            return [2 /*return*/];
                        anchorOffset = typeof payload.anchorIndex === 'number'
                            ? payload.anchorIndex - Math.floor(MEMBER_SCROLL_CHUNK * 0.2)
                            : state.loadedMemberStartIndex - MEMBER_SCROLL_STEP;
                        prevOffset = normalizeWindowOffset({
                            requestedOffset: Math.min(state.loadedMemberStartIndex - MEMBER_SCROLL_STEP, anchorOffset),
                            totalUsers: state.totalUsers
                        });
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, prevOffset);
                        return [4 /*yield*/, dispatch('fetchTimeline', { companyId: payload.companyId })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    fetchProjects: function (_, payload) {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, MemberAllocationApiClient.fetchProjectList({
                            date: payload.date
                        })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.projects) || []];
                }
            });
        });
    },
    fetchProcesses: function (_, payload) {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, MemberAllocationApiClient.fetchProcessList(payload.projectId, {
                            date: payload.date,
                            user_id: payload.userId
                        })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.large_processes) || []];
                }
            });
        });
    },
    fetchConflictTimes: function (_, payload) {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            var params, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        params = {
                            date: payload.date,
                            large_process_id: payload.largeProcessId,
                            user_id: payload.userId,
                            start_time: payload.startTime,
                            end_time: payload.endTime
                        };
                        if (payload.unassignLargeProcessId) {
                            params.unassign_large_process_id = payload.unassignLargeProcessId;
                        }
                        return [4 /*yield*/, MemberAllocationApiClient.fetchConflictTime(params)];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.conflicts) || []];
                }
            });
        });
    },
    reorderMember: function (_a, payload) {
        var commit = _a.commit, state = _a.state, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var companyId, userId, referenceUserId, place, current, sourceIndex, referenceIndex, moved, targetIndex, insertAt, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        companyId = payload.companyId, userId = payload.userId, referenceUserId = payload.referenceUserId, place = payload.place;
                        if (userId === referenceUserId)
                            return [2 /*return*/];
                        current = __spreadArrays(state.loadedMembers);
                        sourceIndex = current.findIndex(function (m) { return m.id === userId; });
                        referenceIndex = current.findIndex(function (m) { return m.id === referenceUserId; });
                        if (sourceIndex < 0 || referenceIndex < 0)
                            return [2 /*return*/];
                        moved = current.splice(sourceIndex, 1)[0];
                        targetIndex = current.findIndex(function (m) { return m.id === referenceUserId; });
                        if (targetIndex < 0)
                            return [2 /*return*/];
                        insertAt = place === 'before' ? targetIndex : targetIndex + 1;
                        current.splice(insertAt, 0, moved);
                        commit(MemberAllocationMutationTypes.UPDATE_MEMBER_LIST, current);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, MemberAllocationApiClient.updateUsersOrder(companyId, {
                                user_id: userId,
                                reference_user_id: referenceUserId,
                                place: place
                            })];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        // If API fails, we revert to original state by re-fetching
                        return [4 /*yield*/, dispatch('initTimeline', { companyId: companyId })];
                    case 4:
                        // If API fails, we revert to original state by re-fetching
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
};
